import React, { useEffect, useState, useRef } from 'react'
import { CLICKED, CMSPath, DEMO, ENABLEDIGITALKEY, EXIT, PRIVACYPOLICY, TERMSANDCONDITIONS, USEOLDLOGOUT } from '../../../config/constant'
import { connect } from 'react-redux'
import { currentWidget, popupOpenClose, setFailScreen, setOpenProfileImage } from '../../../action/action'
import { HashRouter, Link, Redirect } from 'react-router-dom'
import Camera from '../autoCheckin/Camera';
import { validateGuestdetail } from '../../../action/action'
import { fetchSessionToken } from '../../../JS/fetchSessionToken'
import {save_in_persistent, readFileFromUri, getImageURL, getImageDataURL, loadImageFromFile, calculateTimeDifference, getDefaultAnalyticsLabel} from '../../JS/utility';
import { inAppBrowser } from '../../JS/inAppBrowser';
import { logoutUserHandler, sendAnalytics } from '../../../action/homeAction'
import { setDeviceConfigFailed, setChatBubble } from '../../../action/action'
import { ENABLELANGSELECTION } from '../../../config/constant';
import { notificationKeys } from '../../../config/layout2constant';
import {useTranslation} from "react-i18next";
import { setGuestPreferedLang, setGoHome } from '../../action/homeAction';
import SelectLanguageDropdown from '../../UI/selectLanguageDropdown'
import DoorKeyWarning from './doorKeyWarning'
import smooch from 'smooch'
import { convertFileToBase64Native } from '../../../JS/convertFileToBase64'
import { updateInnSpireChatGuestDetails } from '../chatWidget/innpirechatbot'
import Header from './header'

const ProfilePhoto = (props) => {

    const profileImage = `${CMSPath}${props.profile.profileImageUrl}`;
    const [autoCheckinPhoto,setAutoCheckinPhoto] = useState(localStorage.getItem("profile_photo"));
    const [showChangeProfile,setShowChangeProfile] = useState(false);
    const [openCamera,setOpenCamera] = useState(false);
    const [goBackPath,setGoBackPath] = useState(null);
    const [loggingOut,setLoggingOut] = useState(false);
    const [showLangDropdown,setShowLangDropdown] = useState(false);
    const [selectedLang,setSelectedLang] = useState();
    const [testCrashLogCounter, setTestCrashLogCounter ] = useState(0);
    const [testCrashCounter, setTestCrashCounter ] = useState(0);
    const [widgetLaunchTime, setWidgetLaunchTime] = useState(new Date);
    const [showLogoutWarning, setShowLogoutWarning] = useState(false);
    const {t, i18n} = useTranslation('translations');
    const inputFile = useRef(null);
    props.setChatBubble(false)
    const logoutHandler = (logoutWarningShown) => {

        if(localStorage.getItem("isDoorKeyInLayout") == "true" && !logoutWarningShown && localStorage.getItem('door_key_opened') == "true"){
            setShowLogoutWarning(true)
            return;
        }
        setLoggingOut(true);
        let encodData = fetchSessionToken();

        if(USEOLDLOGOUT) {
           props.validateGuestdetail(encodData, "someone", "something",(status) => {
            removePhotoHandler();
            document.location.reload();
            });
        } else {
            props.logoutUserHandler((status, msg) => {
                if(status){
                    removePhotoHandler();
                    // document.location.reload(); 
                }else{
                    setLoggingOut(false);
                    props.setFailScreen(true, msg, "We are not not able to get the data, please check your internet connection or try again", true)
                    props.setGoHome(true);
                }
            });
        }
    }

    const removePhotoHandler = () => {

        localStorage.removeItem("profile_photo");
        setAutoCheckinPhoto(null);
        // document.location.reload();
    }

    const goBackHandler = () => {
        let path = props.selectedHomePage ? notificationKeys.some(el => el === props.selectedHomePage.uniqueKey) ? path = "/notifications" : path = "/" : null;
        setGoBackPath(path);
    }

    const getPhotoFromLibrary = () => {
        
        const options = {
            destinationType: window.Camera.DestinationType.FILE_URI,
            sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY,
        }

        window.navigator.camera.getPicture((imageUri) => {
            setAutoCheckinPhoto(imageUri);
            localStorage.setItem('profile_photo', imageUri)

            convertFileToBase64Native(imageUri, (base64Uri) => {
                if(base64Uri){
                    updateInnSpireChatGuestDetails({photo: base64Uri});
                }
            });

            readFileFromUri(imageUri, (blob) => {save_in_persistent('profile_photo.jpg', blob, (per_uri) =>{
                                                                                                localStorage.setItem('profile_photo', imageUri); onSaveImageSuccess(per_uri)
                                                                                            }, (err)=> {})});
        }, (error) => {
            console.log("__________error",error)
        },options)

    }

    const getPhotoFromLibraryWeb = (e) => {

        if(e.target.files){
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            const imageUri = reader.result;
            setAutoCheckinPhoto(imageUri);
            localStorage.setItem('profile_photo', imageUri)
            updateInnSpireChatGuestDetails({photo: imageUri});
        };

        reader.onerror = (error) => {
            alert('Error converting image to base64', error);
        }}
    }

    const saveImagetoGalleryHandler = (image) => {
        console.log("change profile photo image",image);

        // setAutoCheckinPhoto(image);
        localStorage.setItem('profile_photo', image)
        convertFileToBase64Native(image, (base64Uri) => {
            if(base64Uri){
                updateInnSpireChatGuestDetails({photo: base64Uri});
            }
        });

        if(window.cordova) {
            readFileFromUri(image, (blob) => {save_in_persistent('profile_photo.jpg', blob, (per_uri) =>{
            localStorage.setItem('profile_photo', image); onSaveImageSuccess(per_uri)
            }, (err)=> {console.log('error while saving camera photo')})});
        }
        setShowChangeProfile(false);
        setOpenCamera(false);

        // window.cordova.plugins.imagesaver.saveImageToGallery(image, onSaveImageSuccess, onSaveImageError);
        // readFileFromUri(image, (blob) => {save_in_persistent('profile_photo.jpg', blob, onSaveImageSuccess)});
    }

    const onSaveImageSuccess = (success) => {
        // console.log('--------------success',success);
        // const filename = success.substr(1);
        // loadImageFromFile(`${filename}`, (url) => {
        //     localStorage.setItem("profile_photo",url);
        //     alert(`saved url: ${url}`)
        // });
    }
                                                
    const onSaveImageError = (error) => {
        console.log('--------------error: ' + error);
    }

    const cameraSuccess = (imageUri) => {
        // localStorage.setItem("profile_photo",imageUrl);
        // setAutoCheckinPhoto(localStorage.getItem("profile_photo"))
        setAutoCheckinPhoto(imageUri);
        
    }

    const openLinkHandler = (link, displayName) => {

        if (link) {
            inAppBrowser(link, props, false, {displayName: displayName, dontSetCurrentWidget: true})
        }

    }

    const selectLangHandler = value => {
        let langCode 
        // switch(value){
        //     case 'English': langCode = 'en';
        //         break;
        //     case 'Spanish': langCode = 'es';
        //         break;
        //     case 'French': langCode = 'fr';
        //         break;
        //     case 'Traditional Chinese': langCode = 'zh_CHT';
        //         break;
        //     case 'Simplified Chinese': langCode = 'zh_CHS';
        //         break;
        // }

        props.languagelistData.map( langObj => {
            if(langObj.language == value){
                langCode = langObj.languageCode
                localStorage.setItem('GuestPreferedLangName', langObj.language)
            }
        })

        setGuestPreferedLang(langCode);
        localStorage.setItem('GuestPreferedLang', langCode)
        if(window.FirebasePlugin){
            window.FirebasePlugin.setCrashlyticsCustomKey('GuestSelectedLang', langCode);
        }
        setSelectedLang(value);
        setShowLangDropdown(false);
        console.log('langCode',langCode, value)
        i18n.changeLanguage(langCode)
        window.location.reload();
    }

    const logCrashToFirebase = () => {

        // this will send a test crash to firebase if the click count is == 5

        setTestCrashLogCounter(testCrashLogCounter + 1)
        setTestCrashCounter(testCrashCounter + 1)

        // console.log('testCrashLogCounter', testCrashLogCounter)
        if(window.FirebasePlugin){
            if(testCrashLogCounter == 5){
                window.FirebasePlugin.logError("Test crash log function" )
                console.log('log sent to firebase')
                setTestCrashLogCounter(0)
            }
            // if(testCrashCounter == 30){
            //     window.FirebasePlugin.sendCrash();
            //     window.FirebasePlugin.logMessage("Testing firebase crash");
            //     console.log('test crash sent to firebase')
            //     setTestCrashCounter(0)
            // }
        }
    }

    useEffect(() => {
        props.currentWidget({widgetType: true});
        props.setOpenProfileImage(false);

        // Send Analytics
        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
            props.sendAnalytics(
                props.guestDetail, 
                "Profile Widget", 
                CLICKED, 
                label, 
                0, 
                props.guestIsLoggedIn
            );
            //
        return () => {
            props.currentWidget({});
            // Send Analytics
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');

            let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
            props.sendAnalytics(
                props.guestDetail, 
                "Profile Widget", 
                EXIT, 
                {...label, "duration": duration}, 
                0, 
                props.guestIsLoggedIn
            );
            //

        }
    },[])

    return(

        openCamera ? <Camera heading="Set Profile Picture" selfie = {true} saveImage = {cameraSuccess} changeProfilePhoto = {true}
        image = {autoCheckinPhoto} backBtn = {() => setOpenCamera(false)} click_single_picture = {true} recordVideo={false}
        hidePicturePreview = {() => {saveImagetoGalleryHandler(autoCheckinPhoto);}}/>

        : 
        <>
        <Header
            PageNameFromParent={t('login.heading')}
            GreetingFromParent={t('login.heading_txt')}
            hideProfilePhoto={true}
            header_class={"loginPage"}
            showBackgroundImage={true}
        />
        { showChangeProfile ? 
        <section class="overlay">
            <div class="overlay-window-container">
                <div class="overlay-window loginPage">
                    <div class="overlay-content padding-0">
                        <div class="overlay-header">
                            <div class="overlay-header-title">
                                <h2 style={{color: "#000"}}>{t('profile.heading2')}</h2>
                            </div>
                            <div class="overlay-header-icon"
                            style={{
                                backgroundImage: autoCheckinPhoto && autoCheckinPhoto != "null" ? `url(${autoCheckinPhoto})` : `url('${profileImage}')`,
                                backgroundSize: "cover",
                                backgroundPosition:"center",
                                backgroundRepeat:"no-repeat"
                                }}>
                        
                            </div>
                        </div>
                    </div>
                    <div class="overlay-controls">
                        <button class="button w-100 secondary" onClick = {() => setOpenCamera(true)}>{t('profile.take_photo_btn')}</button>

                        { window.device ? 
                        <button class="button w-100 margin-top-1 secondary" onClick = {getPhotoFromLibrary}>{t('profile.upload_btn')}</button> 
                        : <>
                        <input type={"file"} accept="image/*" style={{ display: 'none' }} onChange={getPhotoFromLibraryWeb} ref={inputFile} />
                        <button class="button w-100 margin-top-1 secondary" onClick={() => inputFile.current.click()}>{t('profile.upload_btn')}</button> 
                        </> }

                        <button class="button w-100 margin-top-1 secondary" onClick = {() => setShowChangeProfile(false)}>{t('profile.close_btn')}</button>
                    </div>
                </div>
            </div>
        </section>
        
        :<section class="overlay">
			<div class="overlay-window-container">
				<div class="overlay-window loginPage">
					<div class="overlay-content padding-0">
						<div class="overlay-header">
							<div class="overlay-header-title">
								<h2 style={{color: "#000"}}>{t('profile.heading1')}</h2>
							</div>
							<div class="overlay-header-icon" onClick={DEMO && logCrashToFirebase}
                            style={{
                                backgroundImage: autoCheckinPhoto && autoCheckinPhoto != "null" ? `url(${autoCheckinPhoto})` : `url('${profileImage}')`,
                                backgroundSize: "cover",
                                backgroundPosition:"center",
                                backgroundRepeat:"no-repeat"
                                }}>
							</div>
						</div>
					</div>
					<div class="overlay-controls profile-photo">
						<button class="button" onClick = {() => setShowChangeProfile(true)} 
                        disabled={loggingOut}
                        style = {{
                            backgroundColor: props.menuColor.assetBackgroundSelectorColor,
                            color: props.menuColor.assetFontSelectorColor
                        }}>{t('profile.change_btn')}</button>
						<button class="button" onClick = {removePhotoHandler}
                        disabled={loggingOut || !autoCheckinPhoto}
                        style = {{
                            backgroundColor: props.menuColor.assetBackgroundSelectorColor,
                            color: props.menuColor.assetFontSelectorColor
                        }}>{t('profile.remove_btn')}</button>
                        {props.langWidget && 
                        <div class="form-row margin-top-1 align-left">
                            <SelectLanguageDropdown/>
                        </div>
                        // <div class="form-row margin-top-1 align-left">
						// 	<label>{t('profile.prefered_lang_lbl')}:</label>
                        //     <div class="custom-select">
                        //         <div className={`select-selected ${showLangDropdown ? "select-arrow-active" : ""}`} onClick = {() => setShowLangDropdown(prev => !prev)}>
                        //             {selectedLang ? selectedLang : "Please select"}
                        //         </div>
                        //         <div className={`select-items ${showLangDropdown ? "" : "select-hide"}`}>{/*["English","French","Simplified Chinese","Traditional Chinese","Spanish"] */}
                        //             {props.languageList.map(el=> (
                        //                 <div key={el} onClick={() => selectLangHandler(el)}>{el}</div>
                        //             ))}
                        //         </div>
                        //     </div>
						// </div>
                    }
						<button class="button w-100 margin-top-1 secondary get-logout" disabled={loggingOut} onClick = {() => logoutHandler()}>{t('profile.logout_btn')}</button>
                        <button className = "button w-100 margin-top-1 secondary get-close" disabled={loggingOut} onClick = {goBackHandler}>{t('profile.close_btn')}</button>
                        <div class="row form-row padding-top-1 padding-bottom-1 app-info">
                            <div class="privacy">
                                {props.privacyPolicyUrl && <p style={{fontWeight:"normal",fontSize:"14px"}} className="w-50 align-left" onClick = {() => openLinkHandler(props.privacyPolicyUrl, "Privacy Policy")}>Privacy Policy</p>}
                                {props.tncUrl && <p style={{fontWeight:"normal",fontSize:"14px"}} className="w-50 align-right" onClick = {() => openLinkHandler(props.tncUrl,"Terms & Conditions")}>Terms & Conditions</p>}
                            </div>
                            <div class="row app-version">
                                <p class="margin-bottom-0" style={{fontSize:'0.8rem'}}>{`V${props.installedAppVersion}(${props.installedAppBuildNo})`}</p>
                            </div>
                        </div>
					</div>
				</div>
			</div>
            {
                showLogoutWarning && <DoorKeyWarning loggingOut={loggingOut} continue={() => {logoutHandler(true)}} cancel={() => setShowLogoutWarning(false)} />
            }
            {goBackPath && <HashRouter>
                <Redirect exact to = {goBackPath}/>
            </HashRouter>}
		</section>   
        }
    </>);
};

const mapStateToProps = state => {
    return {
        profile: state.store.home.currentDuration.brandingInfo.app ?
            state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
        menuColor: state.store.home.MenuColor,
        selectedHomePage: state.store2.currentHomePage,
        langWidget: state.store.home.langWidget,
        guestDetail: state.store.home.guestDetails,
        guestPreferedLang: state.store2.guestPreferedLang,
        clientConfig: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.ENABLE_MULTI_LANGUAGE_SELECTION : "",
        privacyPolicyUrl: state.store.home.privacyPolicyUrl,
        languageCodeList: state.store.home.languageCodeList,
        languageList: state.store.home.languageList,
        languagelistData: state.store.home.languagelistData,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        tncUrl: state.store.home.tncUrl,
        currentHomePage: state.store2.currentHomePage,
    }
}

export default connect(mapStateToProps,{
    currentWidget,
    validateGuestdetail,
    setDeviceConfigFailed,
    logoutUserHandler,
    setChatBubble,
    sendAnalytics,
    setOpenProfileImage,
    setGoHome,
    popupOpenClose,
    setFailScreen
})(ProfilePhoto)